var LaravelElixirBundle = (function (exports) {
'use strict';

$(document).ready(function() {
    $('.hamburger').hover(
    function() {
        hoverOn($(this));
     }, function() {
        hoverOff($(this));
    });

    $('.hamburger').on('click',function(){
        toggleMenu();
    });

    $('.the-x').on('click',function(){
        toggleMenu();
    });

    $('.dropcat-title').on('click',function(e){
        e.preventDefault();
        toggleCats();
    });

    $(document).mouseup(function (e){
    	var container = $(".nav-dropdown");
    	if (!container.is(e.target) && container.has(e.target).length === 0){
    		closeMenu();
    	}
    });
});

function hoverOn(burger){
    burger.children('.outer-burger').animate({
        width:20,
    },200);
    burger.children('.inner-burger').animate({
        width:30,
    },200);
}

function hoverOff(burger){
    burger.children('.outer-burger').animate({
        width:30,
    },200);
    burger.children('.inner-burger').animate({
        width:20,
    },200);
}

function toggleMenu(){
    if($('.nav-dropdown').css('max-height') == '0px'){
        var scrollHeight = document.querySelector('.nav-dropdown').scrollHeight;
        $('.nav-dropdown').animate({
            maxHeight: '2000px',
        },200);
        $('.hamburger').css("display","none");
        $('.the-x').css("display","inline-block");
    } else {
        $('.nav-dropdown').animate({
            maxHeight:'0px',
        },200);
        $('.the-x').css("display","none");
        $('.hamburger').css("display","grid");
    }
}
function closeMenu(){

    $('.nav-dropdown').animate({
        maxHeight:'0px',
    },200);
    $('.the-x').css("display","none");
    $('.hamburger').css("display","grid");
}

function toggleCats(){
    if($('.drop-cats').css('max-height') == '0px'){
        var scrollHeight = document.querySelector('.drop-cats').scrollHeight;
        $('.drop-cats').animate({
            maxHeight: '1500px',
        },200);
        $('.carety').addClass('flip-caret');
    } else {
        $('.carety').removeClass('flip-caret');
        $('.drop-cats').animate({
            maxHeight:'0px',
        },200);
    }

}

return exports;

}({}));
//# sourceMappingURL=animate-hamburgerB.js.map
